import { ref } from 'vue'

export function useDnd() {
    const dragBlock = ref(false)
    const dragComponent = ref(false)
    const dragInProgress = ref(false)

    const beforeLeave = (el) => {
        el.style.setProperty('--real-height', el.offsetHeight + 'px')
    }

    return { dragBlock, dragComponent, dragInProgress, beforeLeave }
}
